"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Filter;
    }
});
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _Hook = /*#__PURE__*/ _interop_require_default(require("~/models/Hook"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _ListViewLevel = /*#__PURE__*/ _interop_require_default(require("~/models/ListViewLevel"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _modelUtils = require("~/utils/modelUtils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Filter = class Filter {
    static castType(filter) {
        return filter && new Filter(filter);
    }
    castType(filter) {
        return filter && new Filter(filter);
    }
    static async supportToggle(_context) {
        return false;
    }
    async getModel(context, ncMeta = _Noco.default.ncMeta) {
        return this.fk_view_id ? (await _View.default.get(context, this.fk_view_id, ncMeta)).getModel(context, ncMeta) : _Model.default.getByIdOrName(context, {
            id: this.fk_model_id
        }, ncMeta);
    }
    static async insert(context, filter, ncMeta = _Noco.default.ncMeta) {
        var _filter_children;
        const insertObj = (0, _extractProps.extractProps)(filter, [
            'id',
            'fk_view_id',
            'fk_hook_id',
            'fk_level_id',
            'fk_link_col_id',
            'fk_value_col_id',
            'fk_parent_column_id',
            'fk_row_color_condition_id',
            'fk_rls_policy_id',
            'fk_button_col_id',
            'fk_column_id',
            'comparison_op',
            'comparison_sub_op',
            'value',
            'fk_parent_id',
            'is_group',
            'logical_op',
            'base_id',
            'source_id',
            'order',
            'meta',
            'enabled'
        ]);
        const referencedModelColName = [
            'fk_parent_column_id',
            'fk_view_id',
            'fk_hook_id',
            'fk_row_color_condition_id',
            'fk_link_col_id',
            'fk_rls_policy_id',
            'fk_button_col_id'
        ].find((k)=>filter[k]);
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.FILTER_EXP, {
            [referencedModelColName]: filter[referencedModelColName]
        });
        if (!filter.source_id) {
            let model;
            if (filter.fk_view_id && !filter.fk_parent_column_id) {
                model = await _View.default.get(context, filter.fk_view_id, ncMeta);
            } else if (filter.fk_hook_id) {
                model = await _Hook.default.get(context, filter.fk_hook_id, ncMeta);
            } else if (filter.fk_link_col_id) {
                model = await _Column.default.get(context, {
                    colId: filter.fk_link_col_id
                }, ncMeta);
            } else if (filter.fk_parent_column_id) {
                model = await _Column.default.get(context, {
                    colId: filter.fk_parent_column_id
                }, ncMeta);
            } else if (filter.fk_button_col_id) {
                model = await _Column.default.get(context, {
                    colId: filter.fk_button_col_id
                }, ncMeta);
            } else if (filter.fk_column_id) {
                model = await _Column.default.get(context, {
                    colId: filter.fk_column_id
                }, ncMeta);
            } else if (filter.fk_level_id) {
                const level = await _ListViewLevel.default.get(context, filter.fk_level_id, ncMeta);
                if (level == null ? void 0 : level.fk_model_id) {
                    model = await _Model.default.get(context, level.fk_model_id, ncMeta);
                }
            } else {
                _catchError.NcError.invalidFilter(JSON.stringify(filter));
            }
            if (model != null) {
                insertObj.source_id = model.source_id;
            }
        }
        if (!insertObj.meta) {
            insertObj.meta = {};
        }
        insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        const row = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, insertObj);
        if (filter == null ? void 0 : (_filter_children = filter.children) == null ? void 0 : _filter_children.length) {
            await Promise.all(filter.children.map((f)=>this.insert(context, _extends({}, f, {
                    fk_parent_id: row.id,
                    [referencedModelColName]: filter[referencedModelColName]
                }), ncMeta)));
        }
        return await this.redisPostInsert(context, row.id, filter, ncMeta);
    }
    static async redisPostInsert(context, id, filter, ncMeta = _Noco.default.ncMeta) {
        if (!(id && (filter.fk_view_id || filter.fk_hook_id || filter.fk_parent_column_id || filter.fk_level_id || filter.fk_button_col_id))) {
            _catchError.NcError.get(context).badRequest(`Mandatory fields missing in FILTER_EXP cache population : id(${id}), fk_view_id(${filter.fk_view_id}), fk_hook_id(${filter.fk_hook_id}), fk_parent_column_id(${filter.fk_parent_column_id}), fk_level_id(${filter.fk_level_id}), fk_button_col_id(${filter.fk_button_col_id})`);
        }
        const key = `${_globals.CacheScope.FILTER_EXP}:${id}`;
        let value = await _NocoCache.default.get(context, key, _globals.CacheGetType.TYPE_OBJECT);
        if (!value) {
            /* get from db */ value = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, id);
            /* store in redis */ await _NocoCache.default.set(context, key, value).then(async ()=>{
                /* append key to relevant lists */ const p = [];
                if (filter.fk_view_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.VIEW,
                        filter.fk_view_id
                    ], key));
                }
                if (filter.fk_hook_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.HOOK,
                        filter.fk_hook_id
                    ], key));
                }
                if (filter.fk_parent_column_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.PARENT_COLUMN,
                        filter.fk_parent_column_id
                    ], key));
                }
                if (filter.fk_parent_id) {
                    if (filter.fk_view_id) {
                        p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                            _globals.FilterCacheScope.VIEW,
                            filter.fk_view_id,
                            filter.fk_parent_id
                        ], key));
                    }
                    if (filter.fk_hook_id) {
                        p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                            _globals.FilterCacheScope.HOOK,
                            filter.fk_hook_id,
                            filter.fk_parent_id
                        ], key));
                    }
                    if (filter.fk_parent_column_id) {
                        p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                            _globals.FilterCacheScope.PARENT_COLUMN,
                            filter.fk_parent_column_id,
                            filter.fk_parent_id
                        ], key));
                    }
                    if (filter.fk_rls_policy_id) {
                        p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                            _globals.FilterCacheScope.RLS_POLICY,
                            filter.fk_rls_policy_id,
                            filter.fk_parent_id
                        ], key));
                    }
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.PARENT,
                        filter.fk_parent_id
                    ], key));
                }
                if (filter.fk_column_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.COLUMN,
                        filter.fk_column_id
                    ], key));
                }
                if (filter.fk_rls_policy_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.RLS_POLICY,
                        filter.fk_rls_policy_id
                    ], key));
                }
                if (filter.fk_button_col_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.BUTTON_COLUMN,
                        filter.fk_button_col_id
                    ], key));
                }
                await Promise.all(p);
            });
        }
        // on new filter creation delete any optimised single query cache
        {
            // if not a view filter then no need to delete
            if (filter.fk_view_id) {
                const view = await _View.default.get(context, filter.fk_view_id, ncMeta);
                await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                    view
                ], ncMeta);
            }
        }
        return this.castType(value);
    }
    static async update(context, id, filter, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(filter, [
            'fk_column_id',
            'comparison_op',
            'comparison_sub_op',
            'value',
            'fk_parent_id',
            'is_group',
            'logical_op',
            'fk_value_col_id',
            'meta',
            'order',
            'enabled'
        ]);
        if (typeof updateObj.value === 'string') {
            updateObj.value = updateObj.value.slice(0, 255);
        }
        if (!updateObj.meta) {
            updateObj.meta = {};
        }
        updateObj.meta = (0, _modelUtils.stringifyMetaProp)(updateObj);
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, updateObj, id);
        ncMeta.knex.attachToTransaction(async ()=>{
            await _NocoCache.default.update(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, updateObj);
        });
        // on update delete any optimised single query cache
        {
            const filter = await this.get(context, id, ncMeta);
            // if not a view filter then no need to delete
            if (filter.fk_view_id) {
                const view = await _View.default.get(context, filter.fk_view_id, ncMeta);
                await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                    {
                        id: filter.fk_view_id
                    }
                ], ncMeta);
            }
        }
        return res;
    }
    static async delete(context, id, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.get(context, id, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter || filter.id === filter.fk_parent_id) return;
            for (const f of await (filter == null ? void 0 : filter.getChildren(context, ncMeta)) || [])await deleteRecursively(f);
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
            await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        };
        await deleteRecursively(filter);
        // delete any optimised single query cache
        {
            // if not a view filter then no need to delete
            if (filter.fk_view_id) {
                const view = await _View.default.get(context, filter.fk_view_id, ncMeta);
                await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                    {
                        id: filter.fk_view_id
                    }
                ], ncMeta);
            }
        }
    }
    getColumn(context, ncMeta = _Noco.default.ncMeta) {
        if (!this.fk_column_id) return null;
        return _Column.default.get(context, {
            colId: this.fk_column_id
        }, ncMeta);
    }
    static async getFiltersByColumn(context, columnId, ncMeta = _Noco.default.ncMeta) {
        if (!columnId) return null;
        const filters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
            condition: {
                fk_column_id: columnId
            }
        });
        return filters == null ? void 0 : filters.map((f)=>this.castType(f));
    }
    async getGroup(context, ncMeta = _Noco.default.ncMeta) {
        if (!this.fk_parent_id) return null;
        let filterObj = await _NocoCache.default.get(context, `${_globals.CacheScope.FILTER_EXP}:${this.fk_parent_id}`, 2);
        if (!filterObj) {
            filterObj = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                id: this.fk_parent_id
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.FILTER_EXP}:${this.fk_parent_id}`, filterObj);
        }
        return this.castType(filterObj);
    }
    async getChildren(context, ncMeta = _Noco.default.ncMeta) {
        if (this.children) return this.children;
        if (!this.is_group || !this.id) return null;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.PARENT,
            this.id
        ], {
            key: 'order'
        });
        let { list: childFilters } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !childFilters.length) {
            childFilters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_id: this.id
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.PARENT,
                this.id
            ], childFilters);
        }
        return childFilters && childFilters.map((f)=>this.castType(f));
    }
    // public static async getFilter({
    //   viewId
    // }: {
    //   viewId: string;
    // }): Promise<Filter> {
    //   if (!viewId) return null;
    //
    //   const filterObj = await ncMeta.metaGet2(
    // context.workspace_id,
    // context.base_id,
    //     MetaTable.FILTER_EXP,
    //     { fk_view_id: viewId, fk_parent_id: null }
    //   );
    //   return filterObj && new Filter(filterObj);
    // }
    static async getFilterObject(context, { viewId, hookId, linkColId, parentColId, widgetId, rlsPolicyId, buttonColId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            parentColId || viewId || hookId || linkColId || widgetId || rlsPolicyId || buttonColId
        ], {
            key: 'order'
        });
        let { list: filters } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filters.length) {
            const condition = {};
            if (viewId && !parentColId) {
                condition.fk_view_id = viewId;
            } else if (hookId) {
                condition.fk_hook_id = hookId;
            } else if (linkColId) {
                condition.fk_link_col_id = linkColId;
            } else if (parentColId) {
                condition.fk_parent_column_id = parentColId;
            } else if (widgetId) {
                condition.fk_widget_id = widgetId;
            } else if (rlsPolicyId) {
                condition.fk_rls_policy_id = rlsPolicyId;
            } else if (buttonColId) {
                condition.fk_button_col_id = buttonColId;
            }
            filters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition,
                orderBy: {
                    order: 'asc'
                }
            });
            let filterCacheScope;
            if (parentColId) {
                filterCacheScope = _globals.FilterCacheScope.PARENT_COLUMN;
            } else if (viewId) {
                filterCacheScope = _globals.FilterCacheScope.VIEW;
            } else if (hookId) {
                filterCacheScope = _globals.FilterCacheScope.HOOK;
            } else if (linkColId) {
                filterCacheScope = _globals.FilterCacheScope.LINK_COL;
            } else if (widgetId) {
                filterCacheScope = _globals.FilterCacheScope.WIDGET;
            } else if (rlsPolicyId) {
                filterCacheScope = _globals.FilterCacheScope.RLS_POLICY;
            } else if (buttonColId) {
                filterCacheScope = _globals.FilterCacheScope.BUTTON_COLUMN;
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                filterCacheScope,
                parentColId || viewId || hookId || linkColId || widgetId || rlsPolicyId || buttonColId
            ], filters);
        }
        const result = {
            is_group: true,
            children: [],
            logical_op: 'and'
        };
        /**
     * NOTE:
     * Earlier implementation relied on filter creation order when attaching children.
     * Now that filters support reordering, creation order is no longer reliable.
     *
     * This caused flattened filters to appear in the wrong sequence, leading to
     * incorrect parent–child relationships during import / duplicate base flows.
     *
     * The new approach explicitly groups by `fk_parent_id`, sorts by `order`,
     * and flattens the tree deterministically to preserve correct hierarchy.
     */ // parentId -> children
        const childrenMap = new Map();
        // 1️⃣ Group by fk_parent_id
        for (const filter of filters){
            var _filter_fk_parent_id;
            const parentId = (_filter_fk_parent_id = filter.fk_parent_id) != null ? _filter_fk_parent_id : 'root';
            if (!childrenMap.has(parentId)) {
                childrenMap.set(parentId, []);
            }
            childrenMap.get(parentId).push(filter);
        }
        // 2️⃣ Sort siblings by order
        for (const [, list] of childrenMap){
            list.sort((a, b)=>{
                var _a_order, _b_order;
                return ((_a_order = a.order) != null ? _a_order : Infinity) - ((_b_order = b.order) != null ? _b_order : Infinity);
            });
        }
        // 3️⃣ DFS → FLAT push (parent first, then children)
        const flat = [];
        const walk = (parentId)=>{
            const children = childrenMap.get(parentId);
            if (!children) return;
            for (const child of children){
                flat.push(child);
                walk(child.id);
            }
        };
        walk('root');
        // 4️⃣ Assign flat ordered result
        result.children = flat;
        return result;
    }
    // skip viewWebhookManager for this, deleteAll is not a standalone operation, it's invoked by view service
    static async deleteAll(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.getFilterObject(context, {
            viewId
        }, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of (filter == null ? void 0 : filter.children) || [])await deleteRecursively(f);
            if (filter.id) {
                await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
                await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        };
        await deleteRecursively(filter);
        // on update delete any optimised single query cache
        {
            const view = await _View.default.get(context, viewId, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
    }
    static async deleteAllByHook(context, hookId, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.getFilterObject(context, {
            hookId
        }, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of (filter == null ? void 0 : filter.children) || [])await deleteRecursively(f);
            if (filter.id) {
                await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
                await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        };
        await deleteRecursively(filter);
    }
    static async deleteAllByRlsPolicy(context, rlsPolicyId, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.getFilterObject(context, {
            rlsPolicyId
        }, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of (filter == null ? void 0 : filter.children) || [])await deleteRecursively(f);
            if (filter.id) {
                await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
                await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        };
        await deleteRecursively(filter);
    }
    static async deleteAllByParentColumn(context, parentColId, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.getFilterObject(context, {
            parentColId
        }, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of (filter == null ? void 0 : filter.children) || [])await deleteRecursively(f);
            if (filter.id) {
                await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
                await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        };
        await deleteRecursively(filter);
    }
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        let filterObj = id && await _NocoCache.default.get(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!filterObj) {
            filterObj = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                id
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, filterObj);
        }
        return this.castType(filterObj);
    }
    static async allViewFilterList(context, { viewId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.VIEW,
            viewId
        ]);
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_view_id: viewId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.VIEW,
                viewId
            ], filterObjs);
        }
        return (filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f))) || [];
    }
    static async allHookFilterList(context, { hookId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.HOOK,
            hookId
        ]);
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_hook_id: hookId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.HOOK,
                hookId
            ], filterObjs);
        }
        return (filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f))) || [];
    }
    static async rootFilterList(context, { viewId }, ncMeta = _Noco.default.ncMeta) {
        var _filterObjs_filter;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.VIEW,
            viewId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.VIEW,
                viewId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : (_filterObjs_filter = filterObjs.filter((f)=>!f.fk_parent_id)) == null ? void 0 : _filterObjs_filter.map((f)=>this.castType(f));
    }
    static async rootFilterListByHook(context, { hookId }, ncMeta = _Noco.default.ncMeta) {
        var _filterObjs_filter;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.VIEW,
            hookId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_hook_id: hookId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.HOOK,
                hookId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : (_filterObjs_filter = filterObjs.filter((f)=>!f.fk_parent_id)) == null ? void 0 : _filterObjs_filter.map((f)=>this.castType(f));
    }
    static async rootFilterListByRlsPolicy(context, { rlsPolicyId }, ncMeta = _Noco.default.ncMeta) {
        var _filterObjs_filter;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.RLS_POLICY,
            rlsPolicyId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_rls_policy_id: rlsPolicyId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.RLS_POLICY,
                rlsPolicyId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : (_filterObjs_filter = filterObjs.filter((f)=>!f.fk_parent_id)) == null ? void 0 : _filterObjs_filter.map((f)=>this.castType(f));
    }
    static async rootFilterListByParentColumn(context, { parentColId }, ncMeta = _Noco.default.ncMeta) {
        var _filterObjs_filter;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.PARENT_COLUMN,
            parentColId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_column_id: parentColId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.PARENT_COLUMN,
                parentColId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : (_filterObjs_filter = filterObjs.filter((f)=>!f.fk_parent_id)) == null ? void 0 : _filterObjs_filter.map((f)=>this.castType(f));
    }
    static async parentFilterList(context, { parentId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.PARENT,
            parentId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_id: parentId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.PARENT,
                parentId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f));
    }
    static async parentFilterListByHook(context, { hookId, parentId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.HOOK,
            hookId,
            parentId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_id: parentId,
                    fk_hook_id: hookId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.HOOK,
                hookId,
                parentId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f));
    }
    static async parentFilterListByParentColumn(context, { parentColId, parentId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.PARENT_COLUMN,
            parentColId,
            parentId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_id: parentId,
                    fk_parent_column_id: parentColId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.PARENT_COLUMN,
                parentColId,
                parentId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f));
    }
    static async hasEmptyOrNullFilters(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const emptyOrNullFilterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
            condition: {
                base_id: baseId
            },
            xcCondition: {
                _or: [
                    {
                        comparison_op: {
                            eq: 'null'
                        }
                    },
                    {
                        comparison_op: {
                            eq: 'notnull'
                        }
                    },
                    {
                        comparison_op: {
                            eq: 'empty'
                        }
                    },
                    {
                        comparison_op: {
                            eq: 'notempty'
                        }
                    }
                ]
            }
        });
        return emptyOrNullFilterObjs.length > 0;
    }
    static async rootFilterListByLink(_context, { columnId: _columnId }, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    static async allLinkFilterList(context, { linkColumnId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.LINK_COL,
            linkColumnId
        ]);
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_link_col_id: linkColumnId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.LINK_COL,
                linkColumnId
            ], filterObjs);
        }
        return (filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f))) || [];
    }
    static async updateAllChildrenLogicalOp(context, { parentFilterId, logicalOp, viewId }, ncMeta = _Noco.default.ncMeta) {
        let filters;
        if (parentFilterId === 'root') {
            filters = await Filter.rootFilterList(context, {
                viewId
            }, ncMeta);
        } else {
            const filter = await this.get(context, parentFilterId);
            if (!filter.is_group) {
                return;
            }
            filters = await filter.getChildren(context, ncMeta);
        }
        for (const child of filters || []){
            await Filter.update(context, child.id, {
                logical_op: logicalOp
            }, ncMeta);
        }
    }
    async extractRelatedParentMetas(context, ncMeta = _Noco.default.ncMeta) {
        let parentData;
        if (this.fk_view_id) {
            parentData = {
                view: await _View.default.get(context, this.fk_view_id, ncMeta)
            };
        } else if (this.fk_hook_id) {
            parentData = {
                hook: await _Hook.default.get(context, this.fk_hook_id, ncMeta)
            };
        } else if (this.fk_link_col_id) {
            parentData = {
                linkColumn: await _Column.default.get(context, {
                    colId: this.fk_link_col_id
                }, ncMeta)
            };
        }
        return parentData;
    }
    static async rootFilterListByWidget(_context, _params, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    static async allButtonFilterList(context, { buttonColId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.BUTTON_COLUMN,
            buttonColId
        ]);
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_button_col_id: buttonColId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.BUTTON_COLUMN,
                buttonColId
            ], filterObjs);
        }
        return (filterObjs == null ? void 0 : filterObjs.map((f)=>this.castType(f))) || [];
    }
    static async rootFilterListByButtonColumn(_context, { buttonColId: _buttonColId }, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    static async deleteAllByButtonColumn(context, buttonColId, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.getFilterObject(context, {
            buttonColId
        }, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of (filter == null ? void 0 : filter.children) || [])await deleteRecursively(f);
            if (filter.id) {
                await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
                await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            }
        };
        await deleteRecursively(filter);
    }
    constructor(data){
        Object.assign(this, data);
        this.meta = (0, _modelUtils.parseMetaProp)(this);
    }
};
